function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "chevron_svg__a",
  d: "M15 20c-.3 0-.5-.1-.7-.3l-8-8c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7l8-8c.3-.3.6-.4 1-.3.3.1.6.4.7.7.1.3 0 .7-.3 1L8.4 11l7.3 7.3c.3.3.4.7.2 1.1-.1.4-.5.6-.9.6z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chevron_svg__a",
  overflow: "visible",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#000F3C"
});

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "chevron_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chevron_svg__a",
  overflow: "visible"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#chevron_svg__b)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "chevron_svg__c",
  d: "M-519-357H481V659H-519z"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chevron_svg__c",
  overflow: "visible",
  fill: "#000F3C"
}));

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "/krr/images/chevron.svg";
export { SvgChevron as ReactComponent };